/** Product scope_keys from `/admin-panel/platform/v2/config`. */

export const TRIVELTA_PRODUCTS = {
  PAM: "pam",
  // The always-on platform umbrella row in product-configs is
  // (product="client_products", scope_key="common"). No legacy fallback
  // exists — `isProductActive(this)` returns true in non-dev when no
  // fallback is passed, so Ops routes stay reachable in prod even if BE
  // omits `common` from the client's catalog.
  OPERATIONS_PLATFORM: "common",
  /** Core Application / Profile product tile in TCM. */
  CORE_APP: "core_app",
  PAYMENTS: "payments",
  SPORTSBOOK: "sportsbook",
  CASINO: "casino",
  POKER: "poker",
  GAME_PASS: "gamepass",
  PIKKEM: "pikkem",
  PREDICTIONS: "predictions",
  /** TCM regulatory product (not the financials Compliance sider tab). */
  COMPLIANCE: "compliance",
} as const;

export type TriveltaProductKey =
  (typeof TRIVELTA_PRODUCTS)[keyof typeof TRIVELTA_PRODUCTS];
